// Added by Sejune Oh on 2020-03-20
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios'

import { Task, TaskMonitoringElement, ACCESS_TOKEN } from '@/helper/define'
import { getCookie } from '@/helper/util'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Study의 Tasks 이력을 조회
interface ReqGetTasksByStudyUID {
  proxyToken: string
  fkStudyId: string
}
interface ResGetTasksByStudyUID {
  items: Task[]
}
export const reqGetTasksByStudyUID = async ({ proxyToken, fkStudyId }: ReqGetTasksByStudyUID) => {
  return await axios.get<ResGetTasksByStudyUID>(`v1/data/${proxyToken}/dcm/studies/${fkStudyId}/tasks`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Create task
interface ReqCreateTask {
  fkStudyId: string
  fkSeriesIds: string[]
  procName: string
  procParams: string
  dryRun: boolean
  proxyToken: string
}
export const reqCreateTask = async ({
  proxyToken,
  fkStudyId,
  fkSeriesIds,
  procName,
  procParams,
  dryRun,
}: ReqCreateTask) => {
  return await axios.post(`v1/data/${proxyToken}/aps/tasks`, {
    fk_study_id: fkStudyId,
    fk_series_ids: fkSeriesIds,
    proc_name: procName,
    proc_params: procParams,
    dry_run: dryRun,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Cancel tasks
export interface ReqTaskControlById {
  proxyToken: string
  taskIds: string[]
}
export const reqCancelTaskById = async ({ proxyToken, taskIds }: ReqTaskControlById) => {
  return await axios.post(`v1/data/${proxyToken}/aps/tasks:cancel`, {
    ids: taskIds,
    proxy_token: proxyToken,
  })
}

export const reqCancelAllWaitingTasks = async (proxyToken: string) => {
  return await axios.post(`v1/data/${proxyToken}/aps/tasks:cancelAllWaiting`)
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Kill tasks
export interface ReqTaskKillById {
  proxyToken: string
  procName: string
  taskId: string
}
export const reqKillTaskByIdWithProcName = async ({ proxyToken, procName, taskId }: ReqTaskKillById) => {
  return await axios.post(`v1/data/${proxyToken}/aps/tasks:kill`, {
    id: taskId,
    proxy_token: proxyToken,
    proc_name: procName,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Restart takss
export const reqRestartTaskById = async ({ proxyToken, taskIds }: ReqTaskControlById) => {
  return await axios.post(`v1/data/${proxyToken}/aps/tasks:restart`, {
    ids: taskIds,
    proxy_token: proxyToken,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Count tasks
interface ResGetTaskCount {
  waiting_count: string
  running_count: string
}
export const reqGetTaskCount = async (proxyToken: string) => {
  return await axios.post<ResGetTaskCount>(`v1/data/${proxyToken}/aps/tasks:count`, {
    proxy_token: proxyToken,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Monitoring tasks
interface ResGetTaskMonit {
  items: TaskMonitoringElement[]
}

export const reqGetTaskMonit = async (proxyToken: string) => {
  return await axios.post<ResGetTaskMonit>(`v1/data/${proxyToken}/aps/tasks:monitoring`, {
    proxy_token: proxyToken,
  })
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Get url for download Task logs
interface GetURLforDownloadTaskLogs {
  proxyToken: string
  studyId: string
  dirName: string
}
export const getURLforDownloadTaskLogs = ({ proxyToken, studyId, dirName }: GetURLforDownloadTaskLogs) => {
  const accessToken = getCookie(ACCESS_TOKEN)
  return `${axios.defaults.baseURL}/v1/data/${proxyToken}/files/logs/${studyId}/${dirName}?access-token=${accessToken}`
}

